function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNewsRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29 8v18a3 3 0 01-3 3H6a3 3 0 01-3-3V3h20v23h2V8h4zM7 12h12v-2H7v2zm0 4h12v-2H7v2zm0 4h12v-2H7v2z",
    fill: props.color
  }));
}

export default SvgIconNewsRexFilled;